var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('auction-dialog', {
    attrs: {
      "title": "경매 호가표 안내"
    },
    on: {
      "open": _vm.init
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }, {
      key: "default",
      fn: function fn() {
        return [_c('v-data-table', {
          staticClass: "v-data-table--default",
          attrs: {
            "headers": _vm.headers,
            "items": _vm.items,
            "hide-default-footer": "",
            "disable-sort": "",
            "items-per-page": -1
          },
          scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
            return header.hasOwnProperty('formatter');
          }), function (header) {
            return {
              key: "item.".concat(header.value),
              fn: function fn(_ref2) {
                var value = _ref2.value;
                return [_vm._v(_vm._s(header.formatter(value)))];
              }
            };
          })], null, true)
        })];
      },
      proxy: true
    }], null, true)
  });
}
var staticRenderFns = []

export { render, staticRenderFns }